import ControlArea from "components/Layout/ControlArea";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getAllPageSections } from "store/actions";
import Icon from "../../assets/svgs/projects.svg";
// import Table from './Table';
import DndTable from "./DndTable";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Loader from "components/shared/Loader";

const Projects = () => {
  const { sections, loading, error } = useSelector((state) => state.section);
  const dispatch = useDispatch();
  const { formatMessage, locale } = useIntl();

  useEffect(() => {
    dispatch(getAllPageSections("departments"));
  }, [dispatch]);

  // error
  useEffect(() => {
    if (error) {
      toast.error(formatMessage({ id: "sendingErrorMessage" }), {
        position: locale === "ar" ? "bottom-left" : "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [error, formatMessage, locale]);

  if (loading) return <Loader />;

  return (
    <>
      <div className="projects-wrap">
        <ControlArea
          btnTxt={<FormattedMessage id={"addDepartment"} />}
          cardTxt={<FormattedMessage id={"departments"} />}
          icon={Icon}
          url="/departments/addDepartment"
        />

        {/* <Table data={sections} loading={loading} /> */}
        <DndProvider backend={HTML5Backend}>
          <DndTable data={sections} />
        </DndProvider>
      </div>
    </>
  );
};

export default Projects;
